import EntityOverviewCard from "../UI/EntityOverviewCard";

const ManagerOverview = ({ manager }) => (
  <EntityOverviewCard
    fields={[
      { label: "Username", value: manager.user.username },
      { label: "Manager ID", value: manager.id },
    ]}
  />
);

export default ManagerOverview;
